/** Which record view opens after import: the Excel-like sheet (default) or the AG Grid table. */
export type RecordView = 'table' | 'spreadsheet';
export const recordViewKey = 'cdr-clarity:record-view:v1';

export function readRecordView(storage: Pick<Storage, 'getItem'>): RecordView {
  try {
    const saved = storage.getItem(recordViewKey);
    return saved === 'table' || saved === 'spreadsheet' ? saved : 'spreadsheet';
  } catch {
    return 'spreadsheet';
  }
}

export function saveRecordView(storage: Pick<Storage, 'setItem'>, view: RecordView): void {
  try {
    storage.setItem(recordViewKey, view);
  } catch {
    // Private browsing or a full store: the choice still applies to this session.
  }
}
